// This is a modded version of the file Configurator.js from lfc-frontend
// The store used in lfc was removed because of issues with duplicate stores
// Als the coloricker feature is not used inn the MOK

import React from 'react'
import PropTypes from 'prop-types'

import DimensionSelect from '../DimensionSelect/DimensionSelect'

import { _ConfiguratorSection as ConfiguratorSection } from './Configurator.styles'
class Configurator extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      renderMode: 'default',
    }

    this.getDimensionDescription = this.getDimensionDescription.bind(this)
    this.getSelectedValueForDimension = this.getSelectedValueForDimension.bind(this)
    this.newValueSelected = this.newValueSelected.bind(this)
  }

  componentDidMount() {
    const dimensions = this.props.dimensions

    dimensions.some(
      (dimension) =>
        (dimension.dimensionGroupCode === 'DOR' || dimension.dimensionGroupCode === 'WDW') &&
        this.setState({ renderMode: 'design' })
    )
  }

  // (instead of the imported helper used in lfc-frontend /MOK)
  getDimensionDescription(dimension, language) {
    return dimension[`hintDescription${language}`]
  }

  getSelectedValueForDimension(dimension) {
    return this.props.selectedValues.find((selectedValue) =>
      dimension.values.find((value) => value.valueId === selectedValue)
    )
  }

  hiddenDimension(dimension) {
    return (
      this.props.dimsHiddenFromMarkets &&
      this.props.dimsHiddenFromMarkets.some((element) => dimension === element.hiddenDimId)
    )
  }

  newValueSelected(newValueId, prevValueId) {
    const handingDimension = this.props.dimensions.filter((dimension) => dimension.dimensionCode === 'dorHanding')

    if (handingDimension.length) {
      const handingDimensionValues = handingDimension[0].values
      const valueMatchesHandingDimension = handingDimensionValues.filter((option) => option.valueId === newValueId)

      if (valueMatchesHandingDimension.length) {
        this.props.handleHandingChange()
      }
    }

    const selectedValues = [...this.props.selectedValues.filter((value) => value !== prevValueId), newValueId]

    this.props.onChange(selectedValues)
  }

  render() {
    const imageThumbnailDimensions = this.props.dimensions.filter(
      (dimension) =>
        dimension.dimensionCode === 'dorHandle' ||
        dimension.dimensionCode === 'dorHanding' ||
        dimension.dimensionCode === 'wdwSPROSS' ||
        dimension.dimensionCode === 'wdwSPROSSDUPLEX' ||
        dimension.dimensionCode === 'wdwSPROSSENERGY' ||
        dimension.dimensionCode === 'wdwMITTPOST'
    )

    const dropdownDimensions = this.props.dimensions.filter(
      (dimension) =>
        dimension.dimensionCode !== 'dorColor' &&
        dimension.dimensionCode !== 'dorInsideColor' &&
        dimension.dimensionCode !== 'dorHandle' &&
        dimension.dimensionCode !== 'dorHanding' &&
        dimension.dimensionCode !== 'wdwColor' &&
        dimension.dimensionCode !== 'wdwInsideColor' &&
        dimension.dimensionCode !== 'wdwSPROSS' &&
        dimension.dimensionCode !== 'wdwSPROSSDUPLEX' &&
        dimension.dimensionCode !== 'wdwSPROSSENERGY'
    )

    const allColorDimensions = this.props.dimensions.filter(
      (dimension) =>
        dimension.dimensionCode === 'dorColor' ||
        dimension.dimensionCode === 'wdwColor' ||
        dimension.dimensionCode === 'dorInsideColor' ||
        dimension.dimensionCode === 'wdwInsideColor'
    )

    return (
      <div className="lfc-configurator">
        {
          // Render lfc-door
          this.state.renderMode === 'design' && (
            <>
              {/* Render dropdown dimensions */}
              <ConfiguratorSection>
                {dropdownDimensions.map((dimension) => {
                  const { dimensionId, dimensionType, values } = dimension

                  if (this.hiddenDimension(dimension.dimensionId)) return null

                  return (
                    <DimensionSelect
                      key={'d'.concat(dimensionId.toString())}
                      id={'d'.concat(dimensionId.toString())}
                      type={dimensionType}
                      name={dimension[`dimensionName${this.props.language}`]}
                      description={
                        this.props.renderDimensionDescriptions &&
                        this.getDimensionDescription(dimension, this.props.language)
                      }
                      language={this.props.language}
                      messages={this.props.messages}
                      values={values}
                      getDimensionName={this.props.getDimensionName}
                      getValueCode={this.props.getValueCode}
                      getValueName={this.props.getValueName}
                      selectedValue={this.getSelectedValueForDimension(dimension)}
                      correctionInformation={this.props.correctionInformation.find(
                        (info) => info.dimensionId === dimensionId
                      )}
                      onChange={this.newValueSelected}
                    />
                  )
                })}
              </ConfiguratorSection>

              {/* Render color dimension, to be displayed as color boxes/thumbnails */}
              <ConfiguratorSection>
                {allColorDimensions.map((dimension) => {
                  const { dimensionId, dimensionCode, values } = dimension

                  if (this.hiddenDimension(dimension.dimensionId)) return null

                  return (
                    <DimensionSelect
                      key={'d'.concat(dimensionId.toString())}
                      id={'d'.concat(dimensionId.toString())}
                      dimensionCode={dimensionCode.toString()}
                      type={'THUMBNAIL'}
                      variant={'COLOR'}
                      name={dimension[`dimensionName${this.props.language}`]}
                      description={
                        this.props.renderDimensionDescriptions &&
                        this.getDimensionDescription(dimension, this.props.language)
                      }
                      language={this.props.language}
                      messages={this.props.messages}
                      values={values}
                      getDimensionName={this.props.getDimensionName}
                      getValueCode={this.props.getValueCode}
                      getValueName={this.props.getValueName}
                      selectedValue={this.getSelectedValueForDimension(dimension)}
                      correctionInformation={this.props.correctionInformation.find(
                        (info) => info.dimensionId === dimensionId
                      )}
                      onChange={this.newValueSelected}
                      // showColorPicker={this.showColorPicker} // behövs ej, MOK
                    />
                  )
                })}
              </ConfiguratorSection>

              {/* Render dimensions related that should be displayed as image thumbnails */}
              <ConfiguratorSection className="thumnail">
                {imageThumbnailDimensions.map((dimension) => {
                  const { dimensionId, dimensionCode, values } = dimension

                  if (this.hiddenDimension(dimension.dimensionId)) return null

                  return (
                    <DimensionSelect
                      key={'d'.concat(dimensionId.toString())}
                      id={'d'.concat(dimensionId.toString())}
                      dimensionCode={dimensionCode.toString()}
                      type={'THUMBNAIL'}
                      variant={'IMAGE'}
                      name={dimension[`dimensionName${this.props.language}`]}
                      description={
                        this.props.renderDimensionDescriptions &&
                        this.getDimensionDescription(dimension, this.props.language)
                      }
                      language={this.props.language}
                      messages={this.props.messages}
                      values={values}
                      getDimensionName={this.props.getDimensionName}
                      getValueCode={this.props.getValueCode}
                      getValueName={this.props.getValueName}
                      selectedValue={this.getSelectedValueForDimension(dimension)}
                      correctionInformation={this.props.correctionInformation.find(
                        (info) => info.dimensionId === dimensionId
                      )}
                      onChange={this.newValueSelected}
                    />
                  )
                })}
              </ConfiguratorSection>
            </>
          )
        }

        {
          // Default rendering method for other lfc products
          this.state.renderMode === 'default' &&
            this.props.dimensions.map((dimension) => {
              if (!this.hiddenDimension(dimension.dimensionId)) {
                return (
                  <DimensionSelect
                    key={'d'.concat(dimension.dimensionId.toString())}
                    id={'d'.concat(dimension.dimensionId.toString())}
                    type={dimension.dimensionType}
                    name={dimension[`dimensionName${this.props.language}`]}
                    description={
                      this.props.renderDimensionDescriptions &&
                      this.getDimensionDescription(dimension, this.props.language)
                    }
                    language={this.props.language}
                    messages={this.props.messages}
                    values={dimension.values}
                    getDimensionName={this.props.getDimensionName}
                    getValueCode={this.props.getValueCode}
                    getValueName={this.props.getValueName}
                    selectedValue={this.getSelectedValueForDimension(dimension)}
                    correctionInformation={this.props.correctionInformation.find(
                      (info) => info.dimensionId === dimension.dimensionId
                    )}
                    onChange={this.newValueSelected}
                  />
                )
              } else return null
            })
        }
      </div>
    )
  }
}

Configurator.propTypes = {
  correctionInformation: PropTypes.arrayOf(
    PropTypes.shape({
      dimensionId: PropTypes.number,
      constraint: PropTypes.object,
    })
  ),
  dimensions: PropTypes.array.isRequired,
  dimsHiddenFromMarkets: PropTypes.array.isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.number).isRequired,
  language: PropTypes.oneOf(['SE', 'NO', 'FI', 'EN']).isRequired,
  messages: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
  env: PropTypes.string,
  lfcMode: PropTypes.string,
  priceHelper: PropTypes.func,
  pricingInfo: PropTypes.string,
  renderDimensionDescriptions: PropTypes.bool,
  updateInProgress: PropTypes.func,
  handleHandingChange: PropTypes.func,
  getDimensionName: PropTypes.func.isRequired,
  getValueCode: PropTypes.func.isRequired,
  getValueName: PropTypes.func.isRequired,
}

export default Configurator
